import styled from 'styled-components';

export const FilesContainer = styled.div`
  display: flex; 
  align-items: center;
  justify-content: center; 
  flex-direction: row;

  svg {
    margin-left: 8px;
    cursor: pointer;
  }
`;

export const Dropzone = styled.div`
  width: 100%;
  height: 180px;
  border: 2px dashed #000;
  margin-top: 26px;

  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-size: 18px;
    color: #465eb6;
    font-weight: bold;
  }
`;

export const FieldInfo = styled.span`
  font-size: 12px;
  color: #425AF4;
`;
